import * as React from "react";
const IntlContext = React.createContext({});
const useIntl = () => React.useContext(IntlContext);
function withIntl(Component) {
  const wrappedName = Component.displayName || Component.name || "Component";
  const WithIntl = (props) => /* @__PURE__ */ React.createElement(IntlContext.Consumer, null, (context) => /* @__PURE__ */ React.createElement(Component, { ...props, intl: context }));
  WithIntl.displayName = `WithIntl(${wrappedName})`;
  return WithIntl;
}
export {
  IntlContext as default,
  useIntl,
  withIntl
};
//# sourceMappingURL=IntlContext.js.map
